/* CORVIA PDP — daily-action ticker (section 09) + sticky CTA bar (past 700px). */
(function () {
  var ACTIONS = [
    '20 minutes of movement.',
    'A heart-smart meal.',
    'A sleep target.',
    'A stress exercise.',
    'A short expert lesson.',
    'A daily reflection.'
  ];

  function initTicker(root) {
    var els = (root || document).querySelectorAll('[data-cv2-ritual-action]');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    els.forEach(function (el) {
      var i = 0;
      el.textContent = ACTIONS[0];
      if (reduce) return;
      setInterval(function () {
        i = (i + 1) % ACTIONS.length;
        el.textContent = ACTIONS[i];
      }, 2400);
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-cv2-sticky-bar]');
    if (!bar) return;
    var shown = false;
    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var show = y > 700;
      if (show !== shown) {
        shown = show;
        bar.classList.toggle('on', show);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initGallery(root) {
    var gal = (root || document).querySelector('#bbGal');
    if (!gal) return;
    var slides = gal.querySelectorAll('[data-bb-slide]');
    var thumbs = gal.querySelectorAll('[data-bb-thumb]');
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s) { s.classList.toggle('on', +s.dataset.bbSlide === i); });
      thumbs.forEach(function (t) { t.classList.toggle('on', +t.dataset.bbThumb === i); });
    }
    var prev = gal.querySelector('[data-bb-prev]');
    var next = gal.querySelector('[data-bb-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(+t.dataset.bbThumb); });
    });
  }

  function initQuantity(root) {
    (root || document).querySelectorAll('.bb-qty').forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-qty-input]');
      if (!input) return;
      var down = wrap.querySelector('[data-bb-qty-down]');
      var up = wrap.querySelector('[data-bb-qty-up]');
      function clamp(v) { return Math.max(1, v); }
      if (down) down.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
      });
      if (up) up.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
      });
    });
  }

  function init(root) {
    initTicker(root);
    initGallery(root);
    initQuantity(root);
    if (!root) initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { initTicker(e.target); });
})();
